import { render } from "./MultiLingualText.vue?vue&type=template&id=4eff4d29&scoped=true"
import script from "./MultiLingualText.vue?vue&type=script&lang=js"
export * from "./MultiLingualText.vue?vue&type=script&lang=js"

import "./MultiLingualText.vue?vue&type=style&index=0&id=4eff4d29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eff4d29"]])

export default __exports__